import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=4ce5efba&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=4ce5efba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5efba",
  null
  
)

export default component.exports